export const tcpa = {
  agencyCode: '304',
  name: 'Texas Comptroller of Public Accounts',
  shortName: 'CPA',
  slug: 'cpa',
  // logo: publicURL('agency-logos/cpa.png')
};
